import React from 'react'
import { useLocation } from 'react-router'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
	

	const useAuth = () => {
        const token = useSelector(state => state.token);
        const isAdmin = useSelector(state => state.user.admin);
        return Boolean(token && isAdmin);
	}
	

	const AdminRoutes = (props) =>{
	    const authorized = useAuth()
		const location = useLocation()
		return authorized ? <Outlet/> : <Navigate to="/home" replace state={{from: location}} />
		// const cat = localStorage.getItem('token');

	
		// 	if(cat !== ""){
		// 		return <Outlet/>
		// 	}
        // return <Navigate to="/login" replace state={{from: location}} />
    }
	
	export default AdminRoutes;
